export const BRAND_CATEGORY = 'category'
export const SELF_ACCOUNTS = 'accounts'
export const ADD_TO_ALL_CONTROLLER_ACCOUNTS = 'add_to_controller_accounts'
